import { Autocomplete } from '@Wonder-Cave/ui';
import { IDropdownValue } from '@Wonder-Cave/ui/dist/Autocomplete';
import { useSendableContactLists } from '@gr/portal/hooks/useContactListOptions';
import { useState } from 'react';

interface IContactListDropdownProps {
  value: IDropdownValue[] | undefined;
  onChange: (newValue?: (IDropdownValue | undefined)[]) => void;
  onBlur?: () => void;
  allClients?: boolean;
  disabled?: boolean;
  errorMessage?: string | undefined;
  showError: boolean;
  gridFilter?: boolean;
}

const NewContactListDropdown = ({
  value,
  onChange,
  onBlur,
  disabled,
  errorMessage,
  showError,
}: IContactListDropdownProps): JSX.Element => {
  const [searchTerm, setSearchTerm] = useState('');
  const { data: contactListData, isPending: contactListLoading } = useSendableContactLists(searchTerm);

  const contactLists: IDropdownValue[] =
    contactListData?.records.map((contactList) => ({
      label: contactList.name ?? '',
      value: contactList.id,
      additionalData: contactList.originalFileName ?? '',
    })) ?? [];

  return (
    <Autocomplete
      label="Contact Lists"
      placeholder="Type to search contacts"
      loading={contactListLoading}
      value={value}
      options={contactLists}
      onChange={onChange}
      onBlur={onBlur}
      refreshOptions={async (searchValue) => setSearchTerm(searchValue)}
      error={errorMessage}
      disabled={disabled}
      multiple
      showError={showError}
    />
  );
};

export default NewContactListDropdown;
